import Swiper from 'swiper';
import { A11y, Autoplay } from 'swiper/modules';

/**
 * Initialize the slider controls
 *
 * @param swiperInstance {object} Swiper instance
 * @param $next {object} DOM Element of the button that sends us to the next slide
 * @param $prev {object} DOM Element of the button that sends us to the previous slide
 */
const initSliderControls = (swiperInstance, $next, $prev) => {
    if ($next !== null && $next !== undefined) {
        $next.addEventListener('click', event => {
            event.preventDefault();
            swiperInstance.slideNext();
        });
    }

    if ($prev !== null && $prev !== undefined) {
        $prev.addEventListener('click', event => {
            event.preventDefault();
            swiperInstance.slidePrev();
        });
    }
};

/**
 * Update the slide count if $target exists.
 *
 * @param $target {object} DOM Element of the counter element
 * @param count {number} The number to be inserted.
 */
const updateSlideCounter = ($target, $info, count) => {
    if (!$target) {
        return;
    }
    if ($info) {
        let infoText = null;
        if (count > 1) {
            infoText = $info.querySelector('.more');
        } else {
            infoText = $info.querySelector('.one');
        }
        if (infoText !== undefined && infoText !== null) {
            infoText.classList.remove('is-hidden');
        }
    }

    $target.innerHTML = count;
};

/** Initialize the sliders. */
export default function initSlider() {
    // Do not initialize the slider in edit mode
    // TODO: mimic the slider via css in edit mode
    if (document.body.classList.contains('has-edit-mode-menu')) {
        return;
    }

    function shuffle(elems) {
        let allElems = (function () {
            let ret = [],
                l = elems.length;
            while (l--) {
                ret[ret.length] = elems[l];
            }
            return ret;
        })();

        let shuffled = (function () {
                let l = allElems.length,
                    ret = [];
                while (l--) {
                    let random = Math.floor(Math.random() * allElems.length),
                        randEl = allElems[random].cloneNode(true);
                    allElems.splice(random, 1);
                    ret[ret.length] = randEl;
                }
                return ret;
            })(),
            l = elems.length;

        while (l--) {
            elems[l].parentNode.insertBefore(shuffled[l], elems[l].nextSibling);
            elems[l].parentNode.removeChild(elems[l]);
        }
    }

    const $containers = document.querySelectorAll('.slider-container');
    $containers.forEach($container => {
        const $slider = $container.querySelector('.swiper');
        const $next = $container.querySelector('[data-action="slideRight"], [data-swiper-action="next"]');
        const $prev = $container.querySelector('[data-action="slideLeft"], [data-swiper-action="prev"]');
        const $swiperInfo = $container.querySelector('.swiper-info');
        const $count = $container.querySelector('.js-swiper-count');

        // Check if we have to set some classes. We need this for the "slider
        // container" fragment as we cannot set css classes on a dropzone or
        // "dropped" fragments inside a dropzone
        if ($container.classList.contains('custom-slider')) {
            const $wrapper = $container.querySelector('.swiper > div');
            $wrapper.classList.add('swiper-wrapper');

            const $slides = $container.querySelectorAll('.swiper > div > div');
            if ($container.classList.contains('shuffle-products')) {
                shuffle($slides);
                const $shuffledSlides = $container.querySelectorAll('.swiper > div > div');
                $shuffledSlides.forEach($slide => {
                    $slide.classList.add('swiper-slide');
                });
            } else {
                $slides.forEach($slide => {
                    $slide.classList.add('swiper-slide');
                });
            }
        }

        // Initialize the slider
        const swiper = new Swiper($slider, {
            rewind: false,
            modules: [A11y],
            a11y: true,
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                640: {
                    slidesPerView: 1.5,
                },
                768: {
                    slidesPerView: 2.5,
                },
            },
            on: {
                /**
                 * Initialize the slider controls, update the counter if it exists and check the amount of slides in
                 * case we have to hide the controls.
                 *
                 * @param swiper {object} Swiper instance
                 */

                afterInit: swiper => {
                    initSliderControls(swiper, $next, $prev);
                    updateSlideCounter($count, $swiperInfo, swiper.slides.length);

                    if (
                        (swiper.currentBreakpoint === '768' && swiper.slides.length < 2.5) ||
                        (swiper.currentBreakpoint === '640' && swiper.slides.length < 1.5) ||
                        (swiper.currentBreakpoint === 'max' && swiper.slides.length <= 1)
                    ) {
                        if ($next !== null && $next !== undefined) {
                            $next.classList.add('is-hidden');
                        }

                        if ($prev !== null && $prev !== undefined) {
                            $prev.classList.add('is-hidden');
                        }
                    } else {
                        if ($next !== null && $next !== undefined) {
                            $next.classList.remove('is-hidden');
                        }

                        if ($prev !== null && $prev !== undefined) {
                            $prev.classList.remove('is-hidden');
                        }
                    }
                },
                slideChange: swiper => {
                    $prev.disabled = !!swiper.isBeginning;
                    $next.disabled = !!swiper.isEnd;
                },
            },
        });
    });
}
